import React from 'react';
import CustomIcon from '@ant-design/icons';

import iconMap from 'assets/icons/icon-map';
import './style.css';

function Icon({
  type,
  size,
  color,
  onClick,
  useAntd = false,
  showPointer = true,
  tagIcon = false,
  ...rest
}: any) {
  const classNames = [];
  const customClassName = rest.className;
  let width = 16;
  let height = 16;
  if (size && typeof size === 'object') {
    ({ width, height } = size);
  } else if (size) {
    width = size;
    height = size;
  }
  if (customClassName) classNames.push(customClassName);
  if (iconMap[type] && !useAntd) {
    const propsObj = {
      ...rest,
      className: classNames.join(' '),
      height,
      width,
      color,
      cursor: showPointer ? 'pointer' : 'auto',
      onClick,
    };
    return (
      <img
        src={iconMap[type]}
        alt="assets"
        {...propsObj}
        className={`margin-5px ${tagIcon ? 'vertical-top' : ''}`}
        {...rest}
      />
    );
  }

  return (
    <CustomIcon
      className={classNames.join(' ')}
      style={{
        fontSize: `${size || 16}`,
        cursor: showPointer ? 'pointer' : 'auto',
        color,
      }}
      type={useAntd ? null : type}
      component={useAntd ? iconMap[type] : null}
      onClick={onClick}
      {...rest}
    />
  );
}

export default Icon;
